import applyAttachmentMods from "./ApplyAttachmentMods";
import modStateKey from "./ModStateKey";

export const itemNeedsBuiltIns = (item, attachments) => {
    if (!item?.BuiltInAttachments?.Key || !Array.isArray(attachments)) { return false; }
    const keys = Array.isArray(item.BuiltInAttachments.Key)
        ? item.BuiltInAttachments.Key
        : [item.BuiltInAttachments.Key];
    return keys.some((key) =>
        attachments.some((a) => a.Key === key) &&
        !item.Attachments?.some((a) => a.Key === key && a.BuiltIn)
    );
};

const applyBuiltInAttachments = (item, attachments) => {
    if (!item?.BuiltInAttachments?.Key || !Array.isArray(attachments)) { return item; }

    const keys = Array.isArray(item.BuiltInAttachments.Key)
        ? item.BuiltInAttachments.Key
        : [item.BuiltInAttachments.Key];

    let newItem = JSON.parse(JSON.stringify(item));
    if (!newItem.Attachments) { newItem.Attachments = []; }

    keys.forEach((key) => {
        const source = attachments.find((a) => a.Key === key);
        if (!source) { return; }
        if (newItem.Attachments.some((a) => a.Key === key && a.BuiltIn)) { return; }

        const attachment = JSON.parse(JSON.stringify(source));
        attachment.BuiltIn = true;

        let baseMods = attachment.BaseMods;
        if (baseMods && !Array.isArray(baseMods)) { baseMods = [baseMods]; }

        if (attachment.AddedMods) {
            const addedMods = Array.isArray(attachment.AddedMods) ? attachment.AddedMods : [attachment.AddedMods];
            if (!newItem.ModStates) { newItem.ModStates = {}; }
            addedMods.forEach((mod, modI) => {
                const count = parseInt(Math.abs(mod.Count) || 1);
                newItem.ModStates[modStateKey(newItem.inventoryID, attachment.Key, mod, modI)] = {
                    installed: Array(count).fill(false),
                    failed: Array(count).fill(false),
                };
            });
        }

        newItem.Attachments.push(attachment);
        newItem.HPUsed = (newItem.HPUsed || 0) + parseInt(attachment.HP || 0);

        if (baseMods) {
            newItem = applyAttachmentMods(newItem, newItem.Attachments.length - 1, baseMods, false, true);
        }
    });

    return newItem;
};

export default applyBuiltInAttachments;
